import { Box } from '@mui/material';
import { useEffect, useState } from 'react';
import FormFields from '../form/FormFields';

const StepTemplateMetaFields = ({
  updateDataCollection,
  dataCollection,
  updateValidation,
  templateMetaData,
}) => {
  const [fields, setFields] = useState([]);
  // check validation
  useEffect(() => {
    if (templateMetaData) {
      setFields(generateFields(templateMetaData));
    }

    //validateDataCollection();
  }, [templateMetaData]);

  useEffect(() => {
    updateValidation(true);
  }, [updateValidation]);

  /*
  const validateDataCollection = async () => {
    if (!validationSchema) return updateValidation(true);

    try {
      await validationSchema.validate(dataCollection);
      // validation passed for the specific field
      updateValidation(true);
    } catch (err) {
      // validation failed for the specific field
      updateValidation(false);
    }
  };
*/

  function generateFields(metaData) {
    const { metaFields } = metaData || {};
    if (!metaFields) return [];

    var defaultValues = {};

    var newFields = [];
    metaFields.forEach((field) => {
      const { label, type, key, preview } = field;

      newFields.push({
        label,
        type: type === 'richTextEditor' ? 'richText' : type,
        key,
      });

      defaultValues[key] = preview || ' ';
    });

    const prevMetaFields = dataCollection.metaFields || {};

    updateDataCollection({
      metaFields: { ...defaultValues, ...prevMetaFields },
    });

    return newFields;
  }

  function handleChange(obj) {
    const prevMetaFields = dataCollection.metaFields || {};
    updateDataCollection({
      metaFields: {
        ...prevMetaFields,
        ...obj,
      },
    });
  }

  return (
    <Box className="flex flex-col gap-4 pt-2">
      <FormFields
        fields={fields}
        updateDataCollection={handleChange}
        dataCollection={dataCollection.metaFields}
        startDataCollection={{}}
      />
    </Box>
  );
};

export default StepTemplateMetaFields;
